interface FilterPanelProps {
  contentType: string;
  region: string;
  year: string;
  genre: string;
  regionOptions: string[];
  yearOptions: string[];
  genreOptions: string[];
  onContentType: (v: string) => void;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onGenre: (v: string) => void;
  onReset: () => void;
}

function Group({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div>
      <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = value === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt)}
              className={`px-3 py-1.5 rounded-md text-xs font-label transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  contentType,
  region,
  year,
  genre,
  regionOptions,
  yearOptions,
  genreOptions,
  onContentType,
  onRegion,
  onYear,
  onGenre,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-heading font-bold text-foreground-950">筛选条件</h2>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs font-label text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-refresh-line text-sm"></i>
          </span>
          重置
        </button>
      </div>
      <Group title="内容类型" options={["全部", "电影", "电视剧"]} value={contentType} onSelect={onContentType} />
      <Group title="地区" options={regionOptions} value={region} onSelect={onRegion} />
      <Group title="年份" options={yearOptions} value={year} onSelect={onYear} />
      <Group title="类型" options={genreOptions} value={genre} onSelect={onGenre} />
    </div>
  );
}